import React from 'react';
import { motion } from 'framer-motion';
import { FaFileAlt, FaCertificate, FaIdCard, FaHome, FaUsers, FaMapMarkerAlt } from 'react-icons/fa';
function CitizenServices({ language }) {
  const citizenServices = [
    {
      srNo: 1,
      serviceName: 'Birth Registration',
      department: 'Registration',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaCertificate />,
      color: '#3498db'
    },
    {
      srNo: 2,
      serviceName: 'Death Registration',
      department: 'Registration',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaFileAlt />,
      color: '#e74c3c'
    },
    {
      srNo: 3,
      serviceName: 'Marriage Registration',
      department: 'Registration',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaIdCard />,
      color: '#2ecc71'
    },
    {
      srNo: 4,
      serviceName: 'Building Permission & Completion Certificate',
      department: 'Registration',
      applicationFee: 'Fee to Designated Officer',
      processingTime: 'Birth Registration Officer',
      requiredDocuments: 'Related Staff Officer',
      icon: <FaHome />,
      color: '#f39c12'
    },
    {
      srNo: 5,
      serviceName: 'No-Objection Certificate for Business',
      department: 'Registration',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaFileAlt />,
      color: '#9b59b6'
    },
    {
      srNo: 6,
      serviceName: 'Water & Sewage Connection',
      department: 'Registration',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaHome />,
      color: '#1abc9c'
    },
    {
      srNo: 7,
      serviceName: 'Development Permission',
      department: '30 Days',
      applicationFee: 'Free',
      processingTime: 'Application to Issue Officer',
      requiredDocuments: 'Birth Registration Officer',
      icon: <FaMapMarkerAlt />,
      color: '#34495e'
    }
  ];

  const villageStats = [
    { label: 'Population', value: '1080', icon: '👥', color: '#3498db' },
    { label: 'PIN Code', value: '401604', icon: '📮', color: '#e74c3c' },
    { label: 'Households', value: '213', icon: '🏠', color: '#2ecc71' },
    { label: 'Literacy Rate', value: '41.48%', icon: '📚', color: '#f39c12' }
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <motion.section 
        className="hero" 
        style={{ height: '50vh', background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Citizen Services
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            Gram Panchayat Nashera - Services Available for Citizens
          </motion.p>
        </div>
      </motion.section>

      {/* Village Stats */}
      <section className="services-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginBottom: '3rem',
              boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
            }}
          >
            <h2 style={{ color: '#2c3e50', marginBottom: '2rem', fontSize: '2rem' }}>
              Nashera Explorer
            </h2>
            <p style={{ color: '#666', marginBottom: '2rem', fontSize: '1.1rem' }}>
              Comprehensive guide to Nashera village, Mokhada, Palghar.<br />
              Explore demographics, sarpanch details, and local amenities.
            </p>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '2rem',
              marginTop: '2rem'
            }}>
              {villageStats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  style={{
                    background: `${stat.color}15`,
                    padding: '1.5rem',
                    borderRadius: '12px',
                    textAlign: 'center',
                    border: `2px solid ${stat.color}30`
                  }}
                >
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>
                    {stat.icon}
                  </div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: stat.color, marginBottom: '0.5rem' }}>
                    {stat.value}
                  </div>
                  <div style={{ color: '#666', fontSize: '1rem' }}>
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Citizens Services Table */}
      <section className="services-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
              color: 'white',
              padding: '2rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginBottom: '3rem',
              boxShadow: '0 10px 30px rgba(255, 107, 53, 0.3)'
            }}
          >
            <h2 style={{ marginBottom: '1rem', fontSize: '2rem' }}>
              Serial Number
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              List of services available for citizens in rural jurisdiction and their details
            </p>
          </motion.div>

          {/* Services Table */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'white',
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              border: '2px solid #e0e0e0'
            }}
          >
            {/* Table Header */}
            <div style={{
              background: 'linear-gradient(135deg, #2c3e50, #34495e)',
              color: 'white',
              padding: '1.5rem',
              display: 'grid',
              gridTemplateColumns: '80px 1fr 120px 120px 200px 200px',
              gap: '1rem',
              fontWeight: '600',
              fontSize: '0.9rem'
            }}>
              <div>Sr. No.</div>
              <div>Service Name</div>
              <div>Department</div>
              <div>Application Fee</div>
              <div>Processing Time</div>
              <div>Required Documents</div>
            </div>

            {/* Table Body */}
            {citizenServices.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                style={{
                  padding: '1.5rem',
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr 120px 120px 200px 200px',
                  gap: '1rem',
                  borderBottom: index < citizenServices.length - 1 ? '1px solid #eee' : 'none',
                  alignItems: 'center',
                  transition: 'all 0.3s ease'
                }}
                whileHover={{ 
                  background: '#f8f9fa',
                  scale: 1.01
                }}
              >
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  background: `${service.color}20`,
                  borderRadius: '50%',
                  color: service.color,
                  fontWeight: 'bold'
                }}>
                  {service.srNo}
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    color: service.color,
                    background: `${service.color}15`,
                    padding: '0.5rem',
                    borderRadius: '8px'
                  }}>
                    {service.icon}
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '1rem' }}>
                      {service.serviceName}
                    </div>
                  </div>
                </div>
                
                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                  {service.department}
                </div>
                
                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                  {service.applicationFee}
                </div>
                
                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                  {service.processingTime}
                </div>
                
                <div style={{ color: '#666', fontSize: '0.9rem' }}>
                  {service.requiredDocuments}
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Additional Information */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: 'white',
              padding: '2.5rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginTop: '3rem'
            }}
          >
            <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>
              📞 Contact for More Information About Services
            </h3>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
              For information or assistance regarding any service, contact your local Gram Panchayat office
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <div>
                <strong>📧 Email:</strong> gpnashera2017@gmail.com
              </div>
              <div>
                <strong>📞 Phone:</strong> +91 9623382104
              </div>
              <div>
                <strong>📍 Address:</strong> Gram Panchayat Nashera, Mokhada, Palghar
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default CitizenServices;